import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../../components/dataDisplay/dataDisplay";

export const DataPoints = function DataPoints() {
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  const dataPoints = useSelector((state) => state.attritionAndCancelReasons.dataPoints);
  const areaChart = useSelector((state) => state.attritionAndCancelReasons.areaChart);
  if (!dataPoints || !dataPoints.length) return null;

  return (
    <div className={`section__el data-points ${areaChart ? "data-points--expanded-width" : ""}`}>
      {dataPoints.map(({ label, changeValue, tooltip, value, type, ...rest }) => {
        return (
          <div key={label} className="data-point">
            <DataDisplay
              disableAnimation={isUserQa}
              key={label}
              label={label}
              value={type === "percentage" ? value * 100 : value}
              type={type}
              toolTipId={label}
              toolTipContent={tooltip}
              {...rest}
              changeProps={{
                changeValue,
                showBorder: true,
                positiveColor: "#c7343e",
                negativeColor: "#21e981"
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
